//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const pulldownDefaultConfig = {
  content: '下拉刷新',
  height: 40,
  autoRefresh: false,
  downContent: '下拉刷新',
  upContent: '释放后刷新',
  loadingContent: '正在刷新...',
  clsPrefix: 'xs-plugin-pulldown-',
}
const pullupDefaultConfig = {
  content: '上拉加载更多',
  pullUpHeight: 60,
  height: 40,
  autoRefresh: false,
  downContent: '释放后加载',
  upContent: '上拉加载更多',
  loadingContent: '加载中...',
  clsPrefix: 'xs-plugin-pullup-',
}
// import BScroll from "better-scroll";
export default {
  name: 'maternal_file',
  data() {
    return {
      confirm_show: false,
      buttonTabVal: 0,
      results: [],
      keyword: '',
      panel_type: '1',
      memberList: [],
      floor_arr: [],
      sort: '2',
      sort_text: '倒序',
      page: '1',
      pullupDefaultConfig: pullupDefaultConfig,
      pulldownDefaultConfig: pulldownDefaultConfig,
    }
  },
  methods: {
    //查看30天内离院的客户
    go_leave_custom() {
      this.$router.push({
        path: './leave_custom_list',
      })
    },
    toBatch() {
      this.$router.push({
        path: './batch_service',
      })
    },
    //倒序顺序
    sortSearchBtn() {
      if (this.sort == '2') {
        this.sort = '1'
        this.sort_text = '顺序'
        this.refresh()
        return
      }
      if (this.sort == '1') {
        this.sort = '2'
        this.sort_text = '倒序'
        this.refresh()
        return
      }
    },
    //tab切换
    tabChange(index) {
      let that = this
      this.buttonTabVal = index
      this.keyword = ''
      if (index == 1) {
        this.sort = '1'
      }
      this.refresh()
    },
    panelClick(item) {
      this.$router.push({
        path: './maternal_service',
        query: {
          id: item.id,
        },
      })
    },
    //时间戳转日期格式
    formatDateTime(inputTime) {
      var date = new Date(parseInt(inputTime) * 1000)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? '0' + d : d
      var h = date.getHours()
      h = h < 10 ? '0' + h : h
      var minute = date.getMinutes()
      var second = date.getSeconds()
      minute = minute < 10 ? '0' + minute : minute
      second = second < 10 ? '0' + second : second
      return y + '-' + m + '-' + d
    },
    //点击搜索
    searchBtn() {
      let that = this
      this.$nextTick(() => {
        that.$refs.scrollerBottom.reset({ top: 0 })
        that.refresh()
      })
    },
    //清空搜索
    clearSearch() {
      this.keyword = ''
      this.refresh()
    },
    isInArray(arr, value) {
      for (let item of arr) {
        if (value === item) {
          return true
        }
      }
      return false
    },
    //请求数据
    apiMemberList(str) {
      this.$vux.loading.show({
        text: '正在加载',
      })
      let that = this
      let params = {
        token: this.$cookie.get('token'),
        type: '4',
        keyword: this.keyword,
        rule: this.buttonTabVal == 0 ? '1' : '2',
        sort: this.sort,
        page: this.page,
      }
      console.info(params)
      Api.memberListApi.memberList(params).then((res) => {
        console.info(res)
        if (res.errcode == 1) {
          this.page++
          this.$nextTick(() => {
            that.$refs.scrollerBottom.reset()
          })
          if (res.data.list.length) {
            for (let item of res.data.list) {
              let list_arr = []
              if (item.list.length) {
                for (let option of item.list) {
                  let _desc =
                    '电话：' +
                    option.phone +
                    '&nbsp;&nbsp;&nbsp;&nbsp;时间：' +
                    this.formatDateTime(option.live_time) +
                    '&nbsp;&nbsp;&nbsp;&nbsp;套餐：' +
                    option.package_name +
                    '&nbsp;&nbsp;&nbsp;&nbsp;房号：' +
                    option.room_name
                  let options = {
                    id: option.id,
                    src: require('../assets/user1.png'),
                    fallbackSrc: require('../assets/user1.png'),
                    title: option.name,
                    desc: _desc,
                    phone: option.phone,
                    package: option.package_name,
                  }
                  list_arr.push(options)
                }
              }
              let obj = {
                floor: item.floor,
                key: item.key,
                list: list_arr,
              }
              let is_have = this.isInArray(this.floor_arr, item.floor)
              if (!is_have) {
                //楼层不在数组
                this.floor_arr.push(item.floor)
                this.memberList.push(obj)
              } else {
                //存在楼层
                let _index = this.floor_arr.indexOf(item.floor)
                for (let val of obj.list) {
                  this.memberList[_index].list.push(val)
                }
              }
              this.$refs.scrollerBottom.donePullup()
            }
            if (str == 'refresh') {
              this.$refs.scrollerBottom.enablePullup() //启用上拉加载插件
              this.$refs.scrollerBottom.donePulldown() //设置下拉刷新操作完成，在数据加载后执行
            }
            if (res.data.page.page == res.data.page.page_count) {
              this.$refs.scrollerBottom.disablePullup() // 禁用上拉加载，在没有更多数据时执行
            } else {
              this.$refs.scrollerBottom.donePullup() //设置上拉加载操作完成，在数据加载后执行
            }
          }
          this.$vux.loading.hide()
        } else {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    //下拉刷新
    refresh() {
      this.memberList = []
      this.page = '1'
      this.floor_arr = []
      this.apiMemberList('refresh')
    },
    //上拉加载
    loadMore() {
      this.apiMemberList()
    },
    goBack() {
      this.confirm_show = true
    },
    onConfirm() {
      this.$router.push({
        path: '/',
      })
      this.$cookie.set('token', '')
      this.$cookie.set('id', '')
    },
    //判断手机横竖屏状态：
    hengshuping() {
      if (window.orientation == 180 || window.orientation == 0) {
        alert('请使用横屏才能达到最佳浏览效果')
      }
    },
  },
  created() {
    // let that = this
    // this.$nextTick(() => {
    //     that.$refs.scrollerBottom.reset({top: 0})
    // })
    this.apiMemberList()
    // 添加事件监听
    // window.addEventListener('orientationchange',function(){
    //     that.hengshuping()
    // },false);
    // window.onscroll = function(){
    //     //变量scrollTop是滚动条滚动时，距离顶部的距离
    //     // var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    //     //变量windowHeight是可视区的高度
    //     var windowHeight = document.documentElement.clientHeight || document.body.clientHeight
    //     //变量scrollHeight是滚动条的总高度
    //     var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight
    //     //滚动条到底部的条件
    //     if(scrollTop+windowHeight==scrollHeight){
    //         //写后台加载数据的函数
    //         // console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight)
    //         that.loadMore()
    //     }
    // }
  },
}



// WEBPACK FOOTER //
// ./src/components/maternal_file.vue